module.exports = __webpack_public_path__ + "static/media/live.d070c41a.svg";